import DateUtils from 'toolkit/DateUtils';
import TimezoneUtils from 'toolkit/TimezoneUtils';

export const getOpenToDate = (
  currentMinDate: Date,
  currentDate: Date | null,
  isMobile: boolean,
  showPreviousMonths?: boolean
) => {
  if (isMobile) {
    if (showPreviousMonths) {
      return DateUtils.END_TODAY;
    }

    return (currentMinDate.getTime() < (currentDate?.getTime() || 0) ? currentMinDate : currentDate) || undefined;
  }

  return undefined;
};

export const getMaxDate = (showPreviousMonths: boolean, timezone?: string | null): Date | undefined => {
  if (showPreviousMonths) {
    if (timezone) {
      return TimezoneUtils.getEndDateWithTimezone(timezone);
    }

    return DateUtils.END_TODAY;
  }

  return undefined;
};

export const getOpenToDateInRange = (
  currentMinDate: Date,
  currentDate: Date | null,
  isMobile: boolean,
  showPreviousMonths?: boolean
) => {
  if (isMobile) {
    return currentMinDate;
  }

  if (showPreviousMonths) {
    return DateUtils.END_TODAY;
  }

  return currentDate || undefined;
};
